import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVRCLISearchCom} from '../containers'
function SVRCLISearchComPage() {
    //we are inet so id is not passed
    console.log('SV*****SVRCLISearchComPage')
    let { id } = useParams();
    let svparams = { 'id': id}

    console.log('SV*****SVRCLISearchComPage',svparams)
    /*
    return ( <div><h3>Cruises List</h3></div>)
    */
    return (
        <SVRCLISearchCom svparams={svparams} ></SVRCLISearchCom>
        
    );

    
}
export default SVRCLISearchComPage